import React from "react";
import styled from "styled-components";
import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  ReferenceLine,
} from "recharts";
import { MeasurementState } from "../../../hooks/useCameras";

const StyledSection = styled.section`
  height: 180px;
  flex: 1;
  /* border: 1px solid red; */
  border-radius: 5px;
`;

export interface CameraGraphProps {
  data: MeasurementState[];
  timestamp: Date | null;
  onGraphClick: (data: { activeLabel: string }) => void;
}

//Layout is determined here
const CameraGraph: React.FC<CameraGraphProps> = props => {
  const { data, onGraphClick } = props;
  return (
    <>
      <StyledSection>
        <ResponsiveContainer width={"100%"} height={"100%"}>
          <LineChart
            className="chart"
            data={data.map(d => ({
              ...d,
              timestamp: d.timestamp.toISOString(),
            }))}
            onClick={props.onGraphClick}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="timestamp"
              interval="preserveStartEnd"
              tickFormatter={(value: any) => {
                try {
                  return new Date(value).toLocaleTimeString();
                } catch (error) {
                  return value;
                }
              }}

              // tickFormatter={(time: number) =>
              //   new Date(time).toLocaleTimeString()
            />
            <YAxis type="number" interval="preserveStartEnd" />
            <Tooltip
              labelFormatter={(value: any) => {
                try {
                  return `${new Date(value).toLocaleDateString()} ${new Date(
                    value
                  ).toLocaleTimeString()}`;
                } catch (error) {
                  return value;
                }
              }}
              formatter={(value: any, name: any) => {
                // if (name === "flow") {
                //   return (value * 5).toFixed(2);
                // }
                if (typeof value === "number") {
                  return value.toFixed(2);
                } else {
                  return value;
                }
              }}
            />
            {props.timestamp && (
              <ReferenceLine x={props.timestamp.toISOString()} stroke="#444" />
            )}
            <Line
              type="monotone"
              dataKey="mood"
              stroke="#aa0000"
              dot={false}
              connectNulls={true}
              isAnimationActive={false}
            />
            <Line
              type="monotone"
              dataKey="density"
              stroke="#00aa00"
              dot={false}
              connectNulls={true}
              isAnimationActive={false}
            />
            <Line
              type="monotone"
              dataKey="flow"
              stroke="#0000aa"
              dot={false}
              connectNulls={true}
              isAnimationActive={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </StyledSection>
    </>
  );
};

export default CameraGraph;
